import { Component, Signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedAuthLogsComponent } from '../shared-auth-logs/shared-auth-logs.component';
import { AuthLog } from '../shared-auth-logs/auth-log.model';
import { ownedAuthLogsStore } from './+state/owned-auth-logs.store';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
  selector: 'auth-owned-auth-logs',
  standalone: true,
  imports: [CommonModule, SharedAuthLogsComponent],
  templateUrl: './owned-auth-logs.component.html',
  styleUrl: './owned-auth-logs.component.scss',
  providers: [ownedAuthLogsStore]
})
export class OwnedAuthLogsComponent {
  readonly store = inject(ownedAuthLogsStore)

  authLogs: Signal<AuthLog[]> = this.store.authLogsEntities;
  totalRecords: Signal<number> = this.store.totalRecords;

  loadAuthLogsLazy(event: TableLazyLoadEvent) {
    this.store.patchLazyLoad(event);
  }
}
